<template>
    <div v-if="loaded && cart.products.length">
        <div class="lead mb-3 mt-4 mt-md-0 fw-semibold">{{ t.cart.summary }}</div>
        <div class="row">
            <div class="col-6 fw-semibold">{{ t.cart.subtotal }}</div>
            <div class="col-6">{{ amountWithCurrency(cart.subtotal) }}</div>
        </div>
        <div
            class="py-2"
            v-if="config.modules.vouchers && loaded && cart.vouchers.length"
        >
            <div class="row">
                <div class="col-6 fw-semibold">{{ t.vouchers.vouchers }}</div>
                <div class="col-6"></div>
            </div>
            <div
                class="row mb-1"
                v-for="voucher in cart.vouchers"
                :key="voucher.id"
            >
                <div class="col-6">
                    {{ voucher.label }}
                    <div>
                        (<b>{{voucher.code}}</b>)
                    </div>
                </div>
                <div class="col align-self-end">
                    -{{ amountWithCurrency(voucher.amount) }}
                    <i class="fas fa-times cursor-pointer cursor-pointer ms-2"
                    @click="deleteVoucher(voucher)"
                    ></i>
                </div>
            </div>
        </div>
        <div
            class="py-2 text-muted"
            v-if="loaded && cart.discounts.length"
        >
            <div
                class="row mb-1"
                v-for="discount in cart.discounts.filter((discount) => discount.type != 'free_product')"
                :key="discount.code"
            >
                <div class="col-6">
                    {{ discount.label }}
                    <div v-if="discount.value && discount.qty">
                        {{ amountWithCurrency(discount.value) }} x{{ discount.qty }}
                    </div>
                    <div v-else-if="discount.value">
                        {{ discount.type == 'percentage' ? discount.value+'%' : amountWithCurrency(discount.value) }}
                    </div>
                </div>
                <div class="col align-self-end">
                    -{{ amountWithCurrency(discount.amount) }}
                </div>
            </div>
        </div>
        <div v-if="config.shipping_providers
        && config.shipping_providers.length
        && cart.shipping_service" class="row">
            <div class="col-6 fw-semibold">
                {{ t.cart.shipping }}
                <div class="small">{{cart.shipping_service.name+(cart.shipping_service.delivery_date ? ' ('+cart.shipping_service.delivery_date+')' : '')}}</div>
            </div>
            <div class="col-6 align-self-end">{{ cart.shipping ? amountWithCurrency(cart.shipping) : t.cart.free }}</div>
        </div>
        <div v-else-if="!config.shipping_providers || !config.shipping_providers.length" class="row">
            <div class="col-6 fw-semibold">{{ t.cart.shipping }}</div>
            <div class="col-6 align-self-end">{{ cart.shipping ? amountWithCurrency(cart.shipping) : t.cart.free }}</div>
        </div>
        <div class="row" v-if="config.modules.gift && cart.total_gift">
            <div class="col-6 fw-semibold">{{ t.cart.total_gift }}</div>
            <div class="col-6 align-self-end">{{ amountWithCurrency(cart.total_gift) }}</div>
        </div>
        <div class="row my-3">
            <div class="col-6 fw-semibold text-uppercase">
                {{ t.cart.total }}
            </div>
            <div class="col-6 align-self-end fw-semibold">
                {{ cart.total ? amountWithCurrency(cart.total) : t.cart.free }}
            </div>
        </div>
        <div class="row text-muted" v-if="config.modules.rewards_points && cart.total_rewards_points">
            <div class="col-6 fw-semibold">{{ t.rewards_points.total_points }}</div>
            <div class="col-6 align-self-end">{{ numberFormat(cart.total_rewards_points)+' '+t.rewards_points.points }}</div>
        </div>
        <div class="py-2 text-muted">
            <div class="row mt-1" v-for="discount in cart.discounts.filter((discount) => discount.type == 'free_product')" :key="discount.id">
                <div class="col-6">{{discount.label}}<br>({{ amountWithCurrency(discount.value) }})</div>
                <div class="col align-self-end">
                    <a :href="discount.free_product.url" target="_blank">{{discount.free_product.name}}</a> <span v-if="discount.free_product.qty">x{{discount.free_product.qty}}</span>
                </div>
            </div>
        </div>
        <div class="row text-muted" v-if="config.modules.delivery_date_selection && cart.delivery_date">
            <div class="col-6 fw-semibold">{{ t.checkout.delivery_date }}</div>
            <div class="col-6 align-self-end">{{ formatDate(cart.delivery_date) }}<span v-if="cart.delivery_time"> ({{ cart.delivery_time }})</span></div>
        </div>
    </div>
</template>

<script>
    import store from '../CartStore'
    export default {
        store: store,
        data() {
            return {
                config: window.config,
                t: window.t,
                voucher: ''
            }
        },
        computed: {
            ...Vuex.mapGetters(['loaded', 'cart']),
        },
        methods: {
            ...Vuex.mapActions(['deleteVoucher']),
        },
        created() {
            EventBus.$on('cart-changed', () => {
                this.$store.dispatch('getCart', false)
            });
        },
    }
</script>
